import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  ElementRef,
  ViewChild,
  Output,
  EventEmitter,
  AfterViewInit,
  Input,
} from '@angular/core';
import { Subscription, tap } from 'rxjs';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { DatePickerYearChangeEvent } from 'primeng/datepicker';
import { PmLoadingComponent } from '@shared/components/pm-loading/pm-loading.component';
import { PmErrorMessageComponent } from '@shared/components/pm-error-message/pm-error-message.component';

import { PMFormFieldComponentType } from '../models/PmFormFieldComponent.type';
import { PmFormFieldLabelComponent } from '../pm-form-field-label/pm-form-field-label.component';
import { PmFormFieldTextComponent } from './pm-form-field-text/pm-form-field-text.component';
import { PmFormFieldPasswordComponent } from './pm-form-field-password/pm-form-field-password.component';
import { PmFormFieldErrorComponent } from './pm-form-field-error/pm-form-field-error.component';
import { PmFormFieldHintComponent } from './pm-form-field-hint/pm-form-field-hint.component';
import { PmFormFieldRadioTileComponent } from './pm-form-field-radio-tile/pm-form-field-radio-tile.component';
import { PmFormFieldAutocompleteComponent } from './pm-form-field-autocomplete/pm-form-field-autocomplete.component';
import { PmFormFieldTimeComponent } from './pm-form-field-time/pm-form-field-time.component';
import { PmFormFieldNumberComponent } from './pm-form-field-number/pm-form-field-number.component';
import { PmFormFieldRadioComponent } from './pm-form-field-radio/pm-form-field-radio.component';
import { PmFormFieldCheckboxComponent } from './pm-form-field-checkbox/pm-form-field-checkbox.component';
import { PmFormFieldPhoneComponent } from '../pm-form-field/pm-form-field-phone/pm-form-field-phone.component';
// import { PmFormFieldPickerComponent } from './pm-form-field-picker/pm-form-field-picker.component';
import { PmFormFieldSliderComponent } from './pm-form-field-slider/pm-form-field-slider.component';
import { PmFormFieldInputOtpComponent } from './pm-form-field-input-otp/pm-form-field-input-otp.component';
import { PmFormFieldCustomInputOtpComponent } from './pm-form-field-custom-input-otp/pm-form-field-custom-input-otp.component';
import { PmFormFieldSelectComponent } from './pm-form-field-select/pm-form-field-select.component';
import { PmFormFieldDateComponent } from './pm-form-field-date/pm-form-field-date.component';
import { PmFormFieldLongTextComponent } from './pm-form-field-long-text/pm-form-field-long-text.component';
import { PmFormFieldSwitchComponent } from './pm-form-field-switch/pm-form-field-switch.component';
import { PmFormFieldToggleSelectComponent } from './pm-form-field-toggle-select/pm-form-field-toggle-select.component';

@Component({
  standalone: true,
  selector: 'pm-form-field',
  imports: [
    CommonModule,
    PmLoadingComponent,
    PmErrorMessageComponent,
    PmFormFieldLabelComponent,
    PmFormFieldTextComponent,
    PmFormFieldPasswordComponent,
    PmFormFieldErrorComponent,
    PmFormFieldRadioTileComponent,
    PmFormFieldAutocompleteComponent,
    PmFormFieldTimeComponent,
    PmFormFieldNumberComponent,
    PmFormFieldRadioComponent,
    PmFormFieldCheckboxComponent,
    PmFormFieldPhoneComponent,
    // PmFormFieldPickerComponent,
    PmFormFieldSliderComponent,
    PmFormFieldInputOtpComponent,
    PmFormFieldDateComponent,
    PmFormFieldHintComponent,
    PmFormFieldSelectComponent,
    PmFormFieldCustomInputOtpComponent,
    PmFormFieldLongTextComponent,
    PmFormFieldSwitchComponent,
    PmFormFieldToggleSelectComponent,
  ],
  templateUrl: './pm-form-field.component.html',
  styleUrl: './pm-form-field.component.scss',
})
export class PmFormFieldComponent
  extends FormFieldComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() defaultValue?: any;
  @Output() valueChanged = new EventEmitter();
  @Output() monthChanged = new EventEmitter<DatePickerYearChangeEvent>();

  @HostListener('document:keyup.enter', ['$event' as any]) onKeydownHandler(
    event: KeyboardEvent
  ) {
    if (typeof this.formField?.onEnter !== 'function') return;
    const input = this.formFieldComponent.nativeElement.querySelector('input');

    if (input && input === document.activeElement) {
      event.preventDefault();
      event.stopPropagation();
      this.formField.onEnter();
    }
  }

  @ViewChild('formFieldComponent', { read: ElementRef })
  formFieldComponent!: ElementRef<HTMLElement>;
  @ViewChild('formFieldComponent')
  formFieldComponentElement!: PMFormFieldComponentType;

  private subs = new Subscription();

  ngOnInit(): void {
    const sub = this.loadData()?.subscribe();
    if (sub) {
      this.subs.add(sub);
    }
  }

  ngAfterViewInit() {
    if (
      this.defaultValue !== undefined &&
      this.ctrl.value !== this.defaultValue
    ) {
      this.ctrl.setValue(this.defaultValue);
      this.formField.value = this.defaultValue;
      if (
        this.formField.type === this.FormFieldTypeEnum.PHONE &&
        this.formFieldComponentElement instanceof PmFormFieldPhoneComponent
      ) {
        this.formFieldComponentElement.initValues();
      }
    }
    const sub = this.ctrl.valueChanges
      .pipe(
        tap((val) => {
          this.valueChanged.emit(val);
        })
      )
      .subscribe();
    this.subs.add(sub);
  }

  onMonthChanged($event: DatePickerYearChangeEvent) {
    this.monthChanged.emit($event);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
